import { Link } from "react-router-dom";
import type { Movie } from "@/mocks/movies";

interface MovieCardProps {
  movie: Movie;
}

export default function MovieCard({ movie }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="reveal group block bg-background-50 border border-background-200 rounded-lg overflow-hidden hover:border-primary-300 transition-colors cursor-pointer"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={movie.cover}
          alt={`${movie.title}海报`}
          title={`${movie.title} - 高清电影资源与剧情介绍`}
          className="w-full h-full object-top object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-secondary-950/70 via-transparent to-transparent opacity-80"></div>
        <span className="absolute top-2 left-2 h-6 px-2 rounded-md bg-secondary-950/70 backdrop-blur text-[11px] font-label text-background-50 flex items-center">
          {movie.year}
        </span>
        <span className="absolute top-2 right-2 h-6 px-2 rounded-md bg-accent-500 text-foreground-950 text-[11px] font-label font-bold flex items-center gap-0.5">
          <i className="ri-star-fill text-[10px]"></i>
          {movie.rating.toFixed(1)}
        </span>
        <div className="absolute bottom-0 left-0 right-0 p-3">
          <span className="inline-flex items-center h-5 px-2 rounded-full bg-primary-500/90 text-background-50 text-[10px] font-label">
            {movie.region}
          </span>
        </div>
      </div>
      <div className="p-3">
        <h3 className="font-heading font-semibold text-foreground-950 text-sm md:text-base truncate group-hover:text-primary-600 transition-colors">
          {movie.title}
        </h3>
        <p className="mt-1.5 text-xs text-foreground-500 truncate">
          {movie.genres.slice(0, 2).join(" · ")}
        </p>
        <div className="mt-2.5 flex flex-wrap gap-1.5">
          {movie.tags.slice(0, 2).map((t) => (
            <span key={t} className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-900 text-[10px] font-label">
              {t}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}